module.exports = {
      id: "canvas-usage",
      viewBox: "0 0 272 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#canvas-usage",
      toString: function () {
        return this.url;
      }
    }